
import { Button } from '@/components/ui/button';
import WhatsAppIcon from '@/components/icons/WhatsAppIcon';
import { pushToDataLayer } from '@/utils/dataLayerUtils';
import { useAmplitudeEvents } from '@/utils/amplitudeEvents';
import { getPropertyShortName } from '@/utils/propertyUtils';

interface BookingActionsProps {
  checkIn?: Date;
  checkOut?: Date;
  guests: string;
  propertyTitle: string;
  airbnbUrl?: string;
  property?: {
    rating: number;
    guests: number;
    reviews?: any[];
    images?: string[];
    host?: { name: string };
  };
  price: number;
  maxGuests: number;
  onBookingClick: () => void;
}

const BookingActions = ({
  checkIn,
  checkOut,
  guests,
  propertyTitle,
  airbnbUrl,
  property,
  price,
  maxGuests,
  onBookingClick
}: BookingActionsProps) => {
  const { trackAirbnbButtonClicked, trackWhatsAppBookingCardClicked } = useAmplitudeEvents();

  const handleAirbnbClick = () => {
    if (airbnbUrl) {
      const propertyShortName = getPropertyShortName(propertyTitle);
      const totalReviews = property?.reviews ? property.reviews.length : 0;
      const totalPhotos = property?.images ? property.images.length : 0;
      const hostName = property?.host?.name || '';

      trackAirbnbButtonClicked(
        checkIn,
        checkOut,
        guests,
        propertyTitle,
        propertyShortName,
        property?.rating || 0,
        property?.guests || maxGuests,
        price,
        totalReviews,
        totalPhotos,
        hostName
      );

      window.open(airbnbUrl, '_blank');
    }
  };

  const handleWhatsAppClick = () => {
    const propertyShortName = getPropertyShortName(propertyTitle);
    const totalReviews = property?.reviews ? property.reviews.length : 0;
    const totalPhotos = property?.images ? property.images.length : 0;
    const hostName = property?.host?.name || '';

    trackWhatsAppBookingCardClicked(
      checkIn,
      checkOut,
      guests,
      propertyTitle,
      propertyShortName,
      property?.rating || 0,
      property?.guests || maxGuests,
      price,
      totalReviews,
      totalPhotos,
      hostName
    );

    // Push event to dataLayer after click
    pushToDataLayer({
      event: 'whatsApp_clicked'
    });
    

    const message = `Hola! Me gustaría realizar una reservación en: ${propertyTitle}`;
    const whatsappUrl = `https://api.whatsapp.com/send?phone=+523335781778&text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="mt-6 space-y-4">
      <Button 
        onClick={onBookingClick} 
        className="w-full h-12 text-white rounded-lg bg-blue-600 hover:bg-blue-700"
        disabled={!checkIn || !checkOut}
      >
        Solicitar reservación
      </Button>
      
      <div className="flex space-x-4">
        {airbnbUrl && (
          <Button
            onClick={handleAirbnbClick}
            variant="outline"
            className="flex-1 h-12 rounded-lg border-red-500 text-red-500 hover:bg-red-50 bg-white"
            style={{ width: '80%' }}
          >
            Reservar en Airbnb
          </Button>
        )}
        
        <Button
          onClick={handleWhatsAppClick}
          variant="outline"
          className="h-12 rounded-lg border-green-500 text-green-500 hover:bg-green-50 bg-white flex items-center justify-center"
          style={{ width: '20%' }}
        >
          <WhatsAppIcon className="w-5 h-5 text-green-500" />
        </Button>
      </div>

      <p className="text-center text-sm text-gray-600">Nos pondremos en contacto contigo</p>
    </div>
  );
};

export default BookingActions;
